const BLOCKS = Object.freeze({
	QUOTE_BLOCK: "QuoteBlockRecord",
	TEXT_CENTERED_BLOCK: "TextCenteredBlockRecord",
	HEADER_DESCRIPTION_TWO_COLUMNS_BLOCK: "HeaderDescriptionTwoColumnsBlockRecord",
	HEADER_DESCRIPTION_HALF_WIDTH_BLOCK: "HeaderDescriptionHalfWidthBlockRecord",
	BIG_HEADER_DESCRIPTION_TWO_COLUMNS_BLOCK: "TypographyBigHeaderDescriptionTwoColumnsBlockRecord",
	TEXT_BREAK: "TextBreakRecord",
	TYPOGRAPHY_BIG: "TypographyBigRecord",
	TYPOGRAPHY_MEDIUM_TEXT: "TypographyMediumTextRecord",
	IMAGE_BREAK: "ImageBreakRecord",
	PRODUCTS_ONE_IN_ROW: "ProductsOneInRowRecord",
	PRODUCTS_TWO_IN_ROW: "ProductsTwoInRowRecord",
	PRODUCTS_THREE_IN_ROW: "ProductsThreeInRowRecord",
})

const COMMON = Object.freeze({
	TEXT_WITH_BREAK: "CommonTextWithBreakRecord",
	DESCRIPTION_SLOGAN: "CommonDescriptionSloganRecord",
	TEXT_SMALL_IMAGE: "CommonTextSmallImageRecord",
})

const PAGES = Object.freeze({
	COMPETENCES_PAGE_RECORD: "CommonCompetencesPageRecord",
	SERVICE_PAGE_RECORD: "CommonServicePageRecord",
	PROJECT_TECHNOLOGY_RECORD: "ProjectTechnologyRecord",
	GROUP_BLOG_PAGE_RECORD: "CommonBlogPageRecord",
	DIGITAL_SINGLE_PROJECT_RECORD: "DigitalSingleProjectRecord",
	DESIGN_SINGLE_PROJECT_RECORD: "DesignSingleProjectRecord",
})

const COMPONENTS = Object.freeze({
	STORY_MODULE: "StoryModuleRecord",
	VIDEO_BANNER: "VideoBannerRecord",
	FORM: "ApplicationFormModuleRecord",
	PLEO_BRANCHES: "DigitalPleoBranchesModuleRecord",
	HOW_WE_WORK_MODULE: "HowWeWorkModuleRecord",
	HORIZONTAL_HEADER: "HorizontalBigHeaderRecord",
	PLEO_CONTEXT: "CommonPleoContextRecord",
	TEXT_MODULE: "CommonTextModuleRecord",
	QUICK_CONTACT: "CommonQuickContactRecord",
	WHO_WE_WORKED_WITH: "WhoWeWorkedWithModuleRecord",
	SERVICES_CARDS: "ServicesCardsModuleRecord",
	TILES_WITH_DESCRIPTION: "TilesWithDescriptionRecord",
	AREAS_OF_EXPERTISE: "CommonAreasOfExpertiseRecord",
	CAREER_MODULE: "CommonCareerModuleRecord",
	CHECK_OTHERS: "CheckothersModelRecord",
	DESCRIPTION_LOGO_PLEO: "DescriptionLinePleoModuleRecord",
	NEWS_THUMBNAILS: "NewsThumbnailRecord",
	HOW_WE_CREATE_STORY: "HowWeCreateStoryModuleRecord",
	COMMON_BLOB_SLOGAN: "CommonBlobSloganRecord",
	FEATURED_PROJECTS: "FeaturedProjectsModuleRecord",
	STICKY_HEADING: "StickyHeadingSingleItemRecord",
	TILES_MODULE: "TilesModuleRecord",
	CLIENTS_ABOUT_US_RECORD: "CommonClientsAboutUsModuleRecord",
	TECHNOLOGIES_TILES: "CommonTechnologiesTileRecord",
	NUMBERS_RECORD: "CommonNumbersModuleRecord",
	PROJECTS_GRID: "CommonProjectsGridRecord",
	CHECK_OTHER_SERVICES: "CheckOtherServiceRecord",
	BENEFITS_MODULE: "CommonBenefitsModuleRecord",
	JOB_OFFER_FORM: "CommonJobOfferFormRecord",
	HEADER_DESCRIPTION_BUTTON_BANNER_RECORD: "HeaderDescriptionButtonBannerRecord",
	PROJECT_CATEGORY: "ProjectCategoryRecord",
	PRODUCTS_GRID: "ProductsGridRecord",
	PROJECT_SLIDER: "CommonProjectSliderRecord",
	TECHNOLOGIES_TABLE: "DigitalTechnologiesTableRecord",
	PROJECT_SCOPE: "CommonProjectScopeRecord",
	ASSETS_GALLERY: "DigitalAssetsGalleryRecord",
	ASSET_WITH_HEADER: "DigitalAssetWithHeaderAndDescriptionRecord",
	PROJECT_SECTION_HEADER: "DigitalProjectSectionHeaderRecord",
	PROJECT_RANGE: "DigitalProjectRangeRecord",
	PINNED_TEXT_WITH_IMAGE: "DigitalPinnedTextWithImageRecord",
	SOCIAL_MEDIA: "DigitalSocialMediaModuleRecord",
	ABOUT_TEAM: "DigitalAboutTeamModuleRecord",
	FAQ: "DigitalFaqRecord",
	SINGLE_ASSET: "DigitalSingleAssetRecord",
	HEADER_AND_DESCRIPTION: "DigitalHeaderAndDescriptionRecord",
})

const TYPES = Object.freeze({
	...BLOCKS,
	...COMMON,
	...COMPONENTS,
	PAGES, //no spreading of this object is intentional to separate pages from other types
})

export default TYPES
